import React from 'react';
import { TopToolbar } from 'react-admin';

const CardActions = (props) => (
	<TopToolbar sx={{ justifyContent: 'space-between', alignItems: 'center' }} {...props} />
);

export default CardActions;